import { SearchForm, Group, Item, InputText } from 'mailup-web-components'
import React, { useCallback } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilState, useResetRecoilState } from 'recoil'
import { searchState } from 'Pages/TemplateList/recoil/state/search'
import { fetchTemplatesCallback } from 'Pages/TemplateList/recoil/callbacks/callbacks'
import PropTypes from 'prop-types'
import { resultsState } from 'Pages/TemplateList/recoil/state/results'

export const SearchByName = () => {
  const intl = useIntl()

  const [{ searchText }, setSearch] = useRecoilState(searchState)

  const handleOnChange = ({ target: { value } }) => {
    setSearch(prev => ({
      ...prev,
      searchText: value
    }))
  }

  return (
    <Item>
      <InputText
        data-mu-test='search-form__search-name'
        value={searchText}
        onChange={handleOnChange}
        placeholder={intl.formatMessage({
          id: 'Load.Bee.MyTemplateSearchPlaceholder'
        })}
      />
    </Item>
  )
}

export const Search = ({ type }) => {
  const searchTemplates = useRecoilCallback(fetchTemplatesCallback, [])
  const [{ searchText }, setSearch] = useRecoilState(searchState)
  const intl = useIntl()
  const resetResultState = useResetRecoilState(resultsState)

  const handleSearch = useCallback(() => {
    resetResultState()
    searchTemplates({
      type: type,
      searchText: searchText
    })
  }, [searchText])

  const handleReset = () => {
    resetResultState()
    setSearch(prev => ({
      ...prev,
      searchText: ''
    }))
    searchTemplates({
      type: type,
      searchText: ''
    })
  }

  return (
    <SearchForm
      labelBtnReset={intl.formatMessage({
        id: 'Load.MailupCommon.Reset'
      })}
      labelBtnSearch={intl.formatMessage({
        id: 'Load.MailupCommon.Search'
      })}
      advanced={false}
      onSubmit={handleSearch}
      onClickReset={handleReset}
    >
      <Group>
        <SearchByName />
      </Group>
    </SearchForm>
  )
}

Search.propTypes = {
  type: PropTypes.string
}
